export const Z = {
  toasts: 50,
  globalNav: 100,
  dropdown: 200,
  footer: 1,
}
